import React, { useState, useEffect } from 'react';
import { Grid, TextField, Button, MenuItem, Typography, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import statelist from '../../utils/stateList.json';
import moment from 'moment';
import ValidationFunctions from '../../utils/ValidationFunctions';
import { useSelector, useDispatch } from 'react-redux';
//import AlertDialog from '../../components/errorDialog';
import * as registerActions from '../../core/Store/Actions/RegisterActions';
import { formatPhoneNumber } from '../../components/formatPhone';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/loader';
import { AiOutlineLeft } from 'react-icons/ai';

// const useStyles = makeStyles(theme => ({
//     root: {
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'center',
//       alignItems: 'center',
//       padding: theme.spacing(2),
//   '& .MuiTextField-root': {
//         margin: theme.spacing(1),
//         width: '300px',
//       },
//   '& .MuiButtonBase-root': {
//         margin: theme.spacing(2),
//       },
//     },
//   }));

const RegisterUser = () => {
    //const classes = useStyles();
    // create state variables for each input
    const navigate = useNavigate();
    const loading = useSelector(state => state.registerReducer.loading);
    const dataUser = useSelector(state => state.registerReducer.verifyData);
    const usernameData = useSelector(state => state.registerReducer.userData);
    const userData = useSelector(state => state.registerReducer.userVerifyData);
    const dispatch = useDispatch();
    const { username } = usernameData && usernameData;
    const [openModal, setOpen] = useState(false);
    const [verifyType] = useState(
        username.trim().length == 0 ||
            isNaN(
                username
                    .trim()
                    .replace('(', '')
                    .replace(')', '')
                    .replace('-', '')
                    .replace(' ', ''),
            )
            ? 'email'
            : 'sms',
    );
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState(verifyType === 'email' ? username : '');
    const [password, setPassword] = useState('');
    const [dob, setDob] = useState('');
    const [gender, setGender] = useState('');
    const [phone, setPhone] = useState(verifyType === 'sms' ? username : '');
    const [conPassword, setConfirmPassword] = useState('');
    const [city, setCity] = useState('');
    const [pincode, setPincode] = useState();
    const [address, setAddress] = useState();
    const [fullName, setFullName] = useState('');
    const [state, setState] = useState();
    const [checkBox, setCheckboxChecked] = useState(false);
    const [matchPass, setMatchPass] = useState(false);
    const [checkPass, setPassCheck] = useState(false);
    const [required, setRequired] = useState('');


    const genderList = [{
        "name": "Male",
        "value": "male"
    },
    {
        "name": "Female",
        "value": "female"
    }];

    useEffect(() => {
        if (dataUser && (dataUser.email || dataUser.first_name)) {
            handleClickOpen();
            const { birth_date, email, first_name, last_name, gender, phone } = dataUser;
            const birthDate = birth_date && moment(new Date(birth_date)).format('YYYY-MM-DDTHH:mm:ss.sssZ');
            setFirstName(first_name ? first_name : '');
            setLastName(last_name ? last_name : '');
            setDob(birthDate);
            setEmail(email && email !== null ? email : '');
            setPhone(phone && phone !== null ? phone : '');
            setGender(gender === 'male' ? 'Male' : 'Female');
        }
    }, [dataUser]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (userData && userData.token) {
            //localStorage.setItem('token', userData.token);
            // localStorage.removeItem('registertoken');
            // localStorage.removeItem('authtoken');
            navigate('/room/success');
        }
    }, [userData]);

    const erroDialog = () => (
        <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">AkosMD</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {`Your account already created by some care navigator.\n Please confirm your account details on registration`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Ok
                    </Button>
            </DialogActions>
        </Dialog>
    );

    const validateUser = () => {
        let isFirstNameValid = ValidationFunctions.checkIsNameValid(
            firstName.trim(),
            'FirstName',
        );
        if (isFirstNameValid) {
            //showSnackbar(isFirstNameValid);
            return;
        }

        let isLastNameValid = ValidationFunctions.checkIsNameValid(
            lastName.trim(),
            'LastName',
        );
        if (isLastNameValid) {
            //showSnackbar(isLastNameValid);
            return;
        }
        if (dob == null || dob.length == 0) {
            return;
        }
        let payload;
        if (dataUser && dataUser.fhir_patient_id) {
            console.log("datauser",dataUser);
            payload = {
                username: verifyType === 'email' ? phone : encodeURIComponent(email),
                fhirPatientId: dataUser && dataUser.fhir_patient_id && String(dataUser.fhir_patient_id)
            }
        } else {
            payload = {
                username: verifyType === 'email' ? phone : encodeURIComponent(email),
                firstName,
                lastName,
                dateOfBirth: dob && moment(dob).format('yyyy-MM-DD'),
            }
        }
        if (payload && payload.username && payload.username.length > 0)
            dispatch(registerActions.validatePatientEmailPhone(payload));
    }

    const onRegister = () => {
        let payload;
        if (dataUser && dataUser.fhir_patient_id) {
            payload = {
                first_name: firstName,
                last_name: lastName,
                birth_date: dob && moment(dob).format('yyyy-MM-DD'),
                email,
                phone: phone,
                gender: gender.toLowerCase(),
                is_consent_accepted: true,
                signatureFullName: fullName,
                password,
                password_confirmation: conPassword,
                verified: verifyType === 'email' ? 'email' : 'phone',
                fhir_patient_id:dataUser.fhir_patient_id,
                address: {
                    city: city,
                    state: state,
                    zip_code: pincode,
                    line_address: address
                    //country
                }
            }
        } else {
            payload = {
                first_name: firstName,
                last_name: lastName,
                birth_date: dob && moment(dob).format('yyyy-MM-DD'),
                email: email && email.length > 0 ? email : null,
                phone: phone && phone.length > 0 ? phone : null,
                gender: gender.toLowerCase(),
                is_consent_accepted: true,
                signatureFullName: fullName,
                password,
                password_confirmation: conPassword,
                verified: verifyType === 'email' ? 'email' : 'phone',
                address: {
                    city: city,
                    state: state,
                    zip_code: pincode,
                    line_address: address
                    //country
                }
            }
        }
        dispatch(
            registerActions.requestRegister(payload),
        );
    }
    const getAdultDate = () => {
        var date = new Date();
        date.setFullYear(date.getFullYear() - 18);
        return moment(date).format('YYYY-MM-DD');
    };
    const handleSubmit = e => {
        e.preventDefault();
        let isPasswordValid = ValidationFunctions.checkIsPasswordValid(
            password.length > 0 ? password : conPassword,
        );
        const x = new Date(dob);
        const y = new Date(getAdultDate());
        if (x > y) {
            setRequired('date');
            return;
        }
        if (isPasswordValid) {
            setPassCheck(true);
            return;
        }
        if (conPassword != password) {
            setMatchPass(true);
            return;
        }
        if (!checkBox) {
            return;
        }
        setRequired('');
        setPassCheck(false);
        setMatchPass(false);
        onRegister();
        //handleClose();
    };

    const onBack = (e) => {
        e.preventDefault();
        navigate('/')
    }
    return (
        <div style={{ padding: '10% 0% 0% 7%', width: '100%' }}>
            <div style={{
                width: "83%",
                backgroundColor: "white",
                //height: "100%",
                display: "flex",
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: '3%'
                //padding:'10% 0% 5% 9%'
            }}>
                <Typography variant="h1" style={{
                    textAlign: "left",
                    fontFamily: 'Manrope',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    fontSize: 28,
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#000000",
                }} >Patient Registration
                </Typography>
                <Button style={{
                    fontFamily: 'Manrope',
                    fontStyle: "normal",
                    fontWeight: 600,
                    fontSize: 24,
                    display: "flex",
                    alignItems: "center",
                    color: "#024C9C",
                    textDecoration: "none",
                }} onClick={onBack}
                    disabled={loading}
                >
                    <AiOutlineLeft />Back</Button>
            </div>
            <Grid >
                {/* <Typography><h2>Registration</h2></Typography> */}
                <form onSubmit={handleSubmit}>
                    <Grid>
                        <Grid style={{ width: '100%', justifyContent: 'space-between' }}>
                            <Grid style={{ width: '100%', justifyContent: 'space-between' }}>
                                <TextField
                                    label="First Name"
                                    variant='standard'
                                    required
                                    value={firstName}
                                    onChange={e => setFirstName(e.target.value)}
                                    style={{ width: '40%', marginRight: 10 }}
                                // onSubmit={()=>{
                                //     validateUser()
                                // }}
                                />
                                <TextField
                                    label="Last Name"
                                    variant='standard'
                                    required
                                    value={lastName}
                                    onChange={e => setLastName(e.target.value)}
                                    style={{ width: '40%' }}
                                />
                            </Grid>
                            <Grid style={{ width: '100%', justifyContent: 'space-between', marginTop: 10 }}>
                                <TextField
                                    label="DOB"
                                    variant='standard'
                                    required={required === 'date' ? true : false}
                                    value={dob}
                                    inputProps={{ max: getAdultDate() }}
                                    type='date'
                                    onChange={e => { setDob(e.target.value); }}
                                    style={{ width: '81%' }}
                                    InputLabelProps={{ shrink: true }}
                                />
                                {required === 'date' && <Typography style={{ color: 'red', fontSize: 14 }}>Please select the correct date of birth </Typography>}

                                {/* <TextField
                                    label="Gender"
                                    variant='standard'
                                    required
                                    select
                                    value={gender}
                                    onChange={e => setGender(e.target.value)}
                                    style={{ width: '40%' }}
                                >
                                    {genderList.map(({ value, name }) => (
                                        <MenuItem value={value} key={value}>
                                            {name}
                                        </MenuItem>
                                    ))}
                                </TextField> */}
                            </Grid>
                            <Grid style={{ width: '100%', justifyContent: 'space-between', marginTop: 10 }}>
                                <TextField
                                    label="Gender"
                                    variant='standard'
                                    required
                                    select
                                    value={gender}
                                    onChange={e => setGender(e.target.value)}
                                    style={{ width: '40%', marginRight: 10 }}
                                >
                                    {genderList.map(({ value, name }) => (
                                        <MenuItem value={value} key={value}>
                                            {name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <TextField
                                    label="Phone"
                                    variant='standard'
                                    type="phone"
                                    value={phone}
                                    onChange={e => { formatPhoneNumber(e.target.value, setPhone) }}
                                    style={{ width: '40%' }}
                                    disabled={verifyType === 'sms' ? username : ''}
                                />
                            </Grid>
                            <Grid style={{ width: '100%', justifyContent: 'space-between', marginTop: 10 }}>
                                <TextField
                                    label="Email"
                                    variant='standard'
                                    type="email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    style={{ width: '81%' }}
                                    disabled={verifyType === 'email' ? true : false}
                                />

                            </Grid>
                            {/* <Grid style={{ width: '100%', justifyContent: 'space-between', marginTop: 10 }}>
                                <TextField
                                    label="Address"
                                    variant='standard'
                                    required
                                    value={address}
                                    onChange={e => setAddress(e.target.value)}
                                    style={{ width: '81%' }}
                                />
                            </Grid> */}
                            <Grid style={{ width: '100%', justifyContent: 'space-between', marginTop: 10 }}>
                                <TextField
                                    label="Address"
                                    variant='standard'
                                    required
                                    value={address}
                                    onChange={e => setAddress(e.target.value)}
                                    style={{ width: '40%', marginRight: 10 }}
                                />
                                <TextField
                                    label="City"
                                    variant='standard'
                                    required
                                    value={city}
                                    onChange={e => setCity(e.target.value)}
                                    style={{ width: '40%' }}
                                />
                            </Grid>
                            <Grid style={{ width: '100%', justifyContent: 'space-between', marginTop: 10 }}>
                                <TextField
                                    label="Pin Code"
                                    variant='standard'
                                    required
                                    type='number'
                                    value={pincode}
                                    onChange={e => setPincode(e.target.value)}
                                    style={{ width: '40%', marginRight: 10 }}
                                />
                                <TextField
                                    label="State"
                                    variant='standard'
                                    required
                                    select
                                    value={state}
                                    onChange={e => { setState(e.target.value) }}
                                    style={{ width: '40%' }}
                                >
                                    {statelist.map(({ value, name }) => (
                                        <MenuItem value={value} key={value}>
                                            {name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid style={{ width: '100%', justifyContent: 'space-between', marginTop: 10 }}>
                                <TextField
                                    label="Password"
                                    variant='standard'
                                    type="password"
                                    required
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    style={{ width: '40%', marginRight: 10 }}
                                />
                                <TextField
                                    label="Confirm Password"
                                    variant='standard'
                                    type="password"
                                    required
                                    value={conPassword}
                                    onChange={e => setConfirmPassword(e.target.value)}
                                    style={{ width: '40%' }}
                                />
                                {checkPass && <Typography style={{ color: 'red', fontSize: 14 }}>Password should have at least 8 characters and must contain at least one uppercase, one lowercase, one number and one special symbol</Typography>}
                                {matchPass && <Typography style={{ color: 'red', fontSize: 14 }}>Password does not match</Typography>}
                            </Grid>
                            <Grid style={{ width: '100%', justifyContent: 'space-between', marginTop: '3%' }}>
                                <TextField
                                    label="Signature Full Name"
                                    variant='standard'
                                    required
                                    value={fullName}
                                    onChange={e => setFullName(e.target.value)}
                                    style={{ width: '81%' }}
                                />
                            </Grid>
                            <Grid style={{ width: '80%', marginTop: '3%' }}>
                                <Checkbox onChange={(e) => { setCheckboxChecked(e.target.checked); }} required />
                                <label style={{ fontFamily: 'Manrope', fontSize: '16px' }}>I accept all <Button style={{ textDecoration: 'underline' }}><a style={{ fontFamily: 'Manrope', fontSize: '16px' }} target="_blank" rel="noopener noreferrer" href='https://akosmd.com/privacy-policy/' >Terms & Conditions and Privacy Policy.</a></Button></label>
                            </Grid>
                            <Grid>
                                <Button style={{
                                    marginTop: '5%', width: '82%', backgroundColor: '#024C9C', fontFamily: 'Manrope', padding: '2%',
                                    fontStyle: "normal", borderRadius: '10px', marginBottom: '5%'
                                }} type="submit" variant="contained" color="primary" disabled={loading}>
                                    {loading && <CircularProgress style={{ margin: '1%' }} style={{color:'#ffffff'}} size={20} />}
                                    {!loading && 'Register'}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
                {/* <Grid style={{ marginTop: '5%', marginBottom: '3%' }}>
                    <Button disabled={loading} style={{
                        width: '50%', backgroundColor: '#ffffff', color: '#024C9C', fontFamily: 'Manrope', padding: '2%',
                        fontStyle: "normal", borderRadius: '10px'
                    }} type="submit" variant="contained" color="primary" onClick={() => navigate('/')}>
                        Back
                    </Button>
                </Grid> */}
                {erroDialog()}
            </Grid>
            {/* {loading && <Loader />} */}
        </div>
    );
}

export default RegisterUser;